<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J0Kk4o/media/FC-9781035804047.jpg?1685790453814" alt="This image is the cover for the book Shadows in the Rainbow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadows in the Rainbow
      </h1>
      <p class="bookDescription body article font2">
        <p>Mel was happily married, until her husband Terry left her for a new life with someone he had more in common with, or so he thought. Then a tall handsome stranger gave her a most precious gift. She was elated, but she was on the road for a life of struggle, there were also small rewards, her son who had issues, but with help, they would get through it. Thank goodness Mel had a great support network, her female family and friends. Mel had her work cut out for her, but she thought, bring it on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Ellery
      </h2>
      
      <p class="authorDescription body article">Sharon Ellery was born and raised in London and still resides there. This is her second novel. Her first novel, Siblings, was published by Austin Macauley Publishers in May, 2022.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb87444e